"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var PlayIconSvg = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return (jsx_runtime_1.jsxs("svg", __assign({ viewBox: "0 0 88 88", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, onClick: onClick }, { children: [jsx_runtime_1.jsx("circle", { cx: "44", cy: "44", r: "44" }, void 0), jsx_runtime_1.jsx("path", { d: "M32 60.7151V27.5152C32 25.9643 33.6886 25.0036 35.0218 25.7959L64.9017 43.554C66.2513 44.3561 66.1929 46.3293 64.7982 47.05L34.9182 62.4919C33.587 63.1798 32 62.2136 32 60.7151Z" }, void 0)] }), void 0));
};
exports.default = PlayIconSvg;
